import { ShipCameraIcon } from './ShipCameraIcon'

/**
 * 간트 막대 행 안의 발주(◆)~입고(●) 사이 구간 띠 + 가운데 'N일' 글자 + 입고 완료 사진 아이콘 (W5-26).
 * 부모(간트 본문 행)가 position:relative 기준. 인덱스는 날짜 칸 번호(0부터), 마커 중심은 idx*DW + DW/2.
 * 띠·글자·아이콘은 pointer-events 없음(마커 드래그를 막지 않음). 띠는 막대 아래 층(zIndex 1, DOM 순서상 막대보다 앞), 글자·아이콘은 막대 위 층.
 */
interface Props {
  /** 보이는 범위로 자른 시작·끝 칸(shipMarkerSpan 결과) */
  fromIdx: number
  toIdx: number
  days: number
  showChip: boolean
  /** 하루 칸 폭(px) */
  DW: number
  /** 입고 완료 사진 아이콘을 그릴 칸(입고 마커 칸, 보이는 범위 안일 때만 전달). null 이면 그리지 않음 */
  cameraIdx?: number | null
  photoCnt?: number
  /** 문구 — 호출부가 logic 상수에서 전달 */
  dayLabel: string
  cameraLabel: string
}

export function ShipGanttMarkerSpan({ fromIdx, toIdx, DW, showChip, dayLabel, cameraIdx, photoCnt, cameraLabel }: Props) {
  const left = fromIdx * DW + DW / 2
  const width = Math.max(0, (toIdx - fromIdx) * DW)
  return (
    <>
      {width > 0 && (
        <div
          aria-hidden="true"
          style={{
            // 리드타임 구간 띠 — 발주 ◆ · 입고 ● 마커(아이콘 + 글자, 높이 약 24px)를 양 끝에 올려 두는 연한 바탕.
            // 선은 마커 아이콘과 높이가 어긋나 보여 쓰지 않는다(◆·● 는 글자 위에 있어 행 가운데보다 위에 있음)
            position: 'absolute', top: '50%', left, width, height: 'var(--num-24)',
            background: 'var(--gt-subtle)', borderRadius: 'var(--radius-full)',
            transform: 'translateY(-50%)',
            pointerEvents: 'none', zIndex: 1,
          }}
        />
      )}
      {width > 0 && showChip && (
        <div
          style={{
            position: 'absolute', top: '50%', left: left + width / 2,
            transform: 'translate(-50%, -50%)',
            color: 'var(--gt-on-subtle)', fontSize: 'var(--type-caption-size)', fontWeight: 600, lineHeight: 1, whiteSpace: 'nowrap',
            pointerEvents: 'none', zIndex: 2,
          }}
        >
          {dayLabel}
        </div>
      )}
      {cameraIdx != null && photoCnt != null && photoCnt > 0 && (
        <span
          role="img"
          aria-label={cameraLabel}
          title={cameraLabel}
          style={{
            position: 'absolute', top: '50%', left: cameraIdx * DW + DW / 2 + 8,
            transform: 'translateY(-50%)', display: 'inline-flex',
            color: 'var(--shell-on-surface)', pointerEvents: 'none', zIndex: 2,
          }}
        >
          <ShipCameraIcon />
        </span>
      )}
    </>
  )
}
